import React from "react";
import HeroSection from "./HeroSection";
import GoToContent from "./GoToContent";

const HeroSectionActivePlan = () => {
  return (
    <HeroSection
      title="PMIstandards+ Success at Your Fingertips"
      tagLine="Enjoy your content."
    >
      <GoToContent />
    </HeroSection>
  );
};

export default HeroSectionActivePlan;
